import { Controller } from '@hotwired/stimulus';

export default class SubmitConfirmationController extends Controller {
  static values = {
    confirmCheckMessage: String,
    confirmUncheckMessage: String
  };

  change(event) {
    const form = this.element.closest('form');
    const message = event.target.checked ? this.confirmCheckMessageValue : this.confirmUncheckMessageValue;

    if (message) {
      if (confirm(message)) {
        Rails.fire(form, 'submit');
      } else {
        event.target.checked = !event.target.checked;
      }
    } else {
      Rails.fire(form, 'submit');
    }
  }
}
